import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR } from '../../utils/const/http';

const getSurveysPerPage = async (page, limit, searchValue, columnName, order) => {
  try {
    const { data } = await axios.get(`/api/surveys?page=${page}&limit=${limit}&searchValue=${searchValue}&columnName=${columnName}&order=${order}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

/**
 * Crea una encuesta con sus preguntas.
 * @param {import('./survey.types').CreateSurveyRequest} surveyInfo Body de la encuesta a crear
 * @returns Encuesta creada
 */
const postNewSurvey = async (surveyInfo) => {
  try {
    const { data } = await axios.post('/api/surveys', surveyInfo);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const duplicateSurvey = async (id) => {
  try {
    const { data } = await axios.get(`/api/duplicate-surveys/${id}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getSurvey = async (id) => {
  try {
    const { data } = await axios.get(`/api/surveys/${id}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getSurveys = async () => {
  try {
    const { data } = await axios.get('/api/surveys-teleaudit');

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getQuestionsTeleaudit = async (id) => {
  try {
    const { data } = await axios.get(`/api/surveys-teleaudit/${id}/questions`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

/**
 * Edita una encuesta y sus preguntas.
 * @param {import('./survey.types').EditSurveyRequest} surveyInfo
 *   Body con la encuesta, sus preguntas y las preguntas a eliminar
 * @returns Encuesta editada
 */
const editSurvey = async (surveyInfo) => {
  try {
    const { data } = await axios.put('/api/survey', surveyInfo);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const errorMessage = err.response?.data?.data?.errorMessage || null;
    return {
      success: false,
      status,
      message: errorMessage,
      data: {
        errorMessage,
      },
    };
  }
};

const deleteSurvey = async (id) => {
  try {
    const { data } = await axios.delete(`/api/survey/${id}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

/**
 * Edita los detalles de una encuesta
 * @param {*} surveyInfo Datos de Survey
 * @returns Datos editados de Survey
 */
const editDetailSurvey = async (surveyInfo) => {
  try {
    const { data } = await axios.put('/api/detail-survey', surveyInfo);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getSurveysByType = async (type) => {
  try {
    const { data } = await axios.get(`/api/survey-list?type=${type}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

export {
  getSurveysPerPage,
  postNewSurvey,
  getSurvey,
  duplicateSurvey,
  editSurvey,
  deleteSurvey,
  getSurveys,
  getQuestionsTeleaudit,
  editDetailSurvey,
  getSurveysByType,
};
